module.exports = __webpack_public_path__ + "static/media/12.811215e5.jpg";